import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Cadastro() {
  const [form, setForm] = useState({ nome_empresa: '', nome_admin: '', email: '', senha: '', telefone: '', cidade: '', estado: '', plano: 'starter', cpf_cnpj: '' });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [faltando, setFaltando] = useState([]); // chaves dos campos inválidos (borda vermelha)
  const [modalAberto, setModalAberto] = useState(false);
  const navigate = useNavigate();
  const setV = (k, v) => {
    setForm(f => ({ ...f, [k]: v }));
    setFaltando(fs => fs.filter(x => x !== k)); // some a borda vermelha assim que o campo é editado
  };

  // Ordem = ordem do formulário (é a ordem da lista no modal)
  const obrigatorios = [
    { k: 'plano', nome: 'Plano', ok: v => !!v },
    { k: 'nome_empresa', nome: 'Nome da Loja', ok: v => !!v.trim() },
    { k: 'cpf_cnpj', nome: 'CNPJ ou CPF', ok: v => { const d = v.replace(/\D/g, ''); return d.length === 11 || d.length === 14; }, msg: 'CNPJ ou CPF (11 ou 14 dígitos)' },
    { k: 'nome_admin', nome: 'Seu Nome', ok: v => !!v.trim() },
    { k: 'telefone', nome: 'Telefone', ok: v => !!v.trim() },
    { k: 'email', nome: 'E-mail', ok: v => !!v.trim() },
    { k: 'senha', nome: 'Senha', ok: v => v.length >= 6, msg: 'Senha (mínimo 6 caracteres)' },
    { k: 'cidade', nome: 'Cidade', ok: v => !!v.trim() },
    { k: 'estado', nome: 'Estado (UF)', ok: v => v.trim().length === 2, msg: 'Estado (UF, 2 letras)' },
  ];
  const invalidos = obrigatorios.filter(c => !c.ok(form[c.k] || ''));
  const azul = '#0066FF';

  const cadastrar = async (e) => {
    e.preventDefault();
    if (invalidos.length) { setFaltando(invalidos.map(c => c.k)); setModalAberto(true); return; }
    setLoading(true); setErro('');
    try {
      await api.post('/empresas/cadastro', form);
      navigate('/login?cadastro=ok');
    } catch(err) {
      setErro(err.response?.data?.error || 'Erro ao criar conta');
    } finally { setLoading(false); }
  };

  const inp = { width: '100%', padding: '11px 14px', border: '1.5px solid #E0E5EF', borderRadius: '8px', fontSize: '14px', fontFamily: "'DM Sans',system-ui,sans-serif", color: '#0D1B2A', background: '#F9FAFB', boxSizing: 'border-box', outline: 'none' };
  const inpErr = k => faltando.includes(k) ? { ...inp, border: '1.5px solid #DC2626', background: '#FEF2F2' } : inp;
  const lbl = { display: 'block', fontSize: '12px', fontWeight: '700', color: '#4B5563', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.4px' };

  const planos = [
    // Valores = PRECOS_PLANOS do backend (services/asaas.js), que é o que o Asaas cobra.
    // `v` vai direto p/ valorPlano(): nome fora da tabela cai no preço do Starter.
    { v: 'starter', nome: 'Starter', preco: 'R$99/mês', desc: 'Até 20 motos no estoque' },
    { v: 'pro', nome: 'Pro', preco: 'R$150/mês', desc: 'Motos ilimitadas + Site + CRM + Financeiro' },
    { v: 'master', nome: 'Master', preco: 'R$299/mês', desc: 'Tudo do Pro + usuários ilimitados' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #EBF3FF 0%, #F0F7FF 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
      <div style={{ width: '100%', maxWidth: '520px' }}>

        {/* LOGO */}
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '28px', fontWeight: '900', color: '#0D1B2A', letterSpacing: '-0.5px' }}>
            Auto<span style={{ color: azul }}>Mais</span>
          </div>
          <div style={{ fontSize: '14px', color: '#6B7280', marginTop: '4px' }}>Crie sua conta gratuita · 14 dias grátis</div>
        </div>

        <div style={{ background: '#fff', borderRadius: '16px', padding: '36px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid #E8ECF4' }}>

          <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#0D1B2A', marginBottom: '24px', textAlign: 'center' }}>Criar conta</h2>

          <form onSubmit={cadastrar} noValidate>

            {/* PLANO */}
            <div style={{ marginBottom: '20px' }}>
              <label style={lbl}>Escolha seu plano</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {planos.map(p => (
                  <div key={p.v} onClick={() => setV('plano', p.v)}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderRadius: '10px', border: `2px solid ${form.plano === p.v ? azul : '#E0E5EF'}`, background: form.plano === p.v ? '#EBF3FF' : '#F9FAFB', cursor: 'pointer', transition: 'all 0.15s' }}>
                    <div>
                      <div style={{ fontSize: '14px', fontWeight: '700', color: form.plano === p.v ? azul : '#0D1B2A' }}>{p.nome}</div>
                      <div style={{ fontSize: '12px', color: '#6B7280' }}>{p.desc}</div>
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: '700', color: form.plano === p.v ? azul : '#4B5563' }}>{p.preco}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ borderTop: '1px solid #E8ECF4', margin: '20px 0' }} />

            {/* DADOS DA EMPRESA */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '14px' }}>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={lbl}>Nome da loja</label>
                <input style={inpErr('nome_empresa')} value={form.nome_empresa} onChange={e => setV('nome_empresa', e.target.value)} placeholder="Ex: Moto Center Fortaleza" />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={lbl}>CNPJ ou CPF</label>
                <input style={inpErr('cpf_cnpj')} inputMode="numeric" maxLength={18} value={form.cpf_cnpj} onChange={e => setV('cpf_cnpj', e.target.value)} placeholder="00.000.000/0000-00" />
              </div>
              <div>
                <label style={lbl}>Seu nome</label>
                <input style={inpErr('nome_admin')} value={form.nome_admin} onChange={e => setV('nome_admin', e.target.value)} placeholder="Nome completo" />
              </div>
              <div>
                <label style={lbl}>Telefone</label>
                <input style={inpErr('telefone')} value={form.telefone} onChange={e => setV('telefone', e.target.value)} placeholder="(85) 99999-9999" />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={lbl}>E-mail</label>
                <input style={inpErr('email')} type="email" value={form.email} onChange={e => setV('email', e.target.value)} placeholder="seu@email.com" />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={lbl}>Senha</label>
                <input style={inpErr('senha')} type="password" value={form.senha} onChange={e => setV('senha', e.target.value)} placeholder="Mínimo 6 caracteres" />
              </div>
              <div>
                <label style={lbl}>Cidade</label>
                <input style={inpErr('cidade')} value={form.cidade} onChange={e => setV('cidade', e.target.value)} placeholder="Fortaleza" />
              </div>
              <div>
                <label style={lbl}>Estado (UF)</label>
                <input style={inpErr('estado')} maxLength={2} value={form.estado} onChange={e => setV('estado', e.target.value.toUpperCase())} placeholder="CE" />
              </div>
            </div>

            {erro && <div style={{ background: '#FEE2E2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>{erro}</div>}

            <button type="submit" disabled={loading}
              style={{ width: '100%', padding: '14px', background: azul, border: 'none', color: '#fff', borderRadius: '10px', cursor: 'pointer', fontWeight: '700', fontSize: '15px', fontFamily: "'DM Sans',system-ui,sans-serif", boxShadow: '0 4px 12px rgba(0,102,255,0.25)', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Criando conta...' : 'Criar conta grátis →'}
            </button>

            <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px', color: '#6B7280' }}>
              Já tem conta?{' '}
              <span onClick={() => navigate('/login')} style={{ color: azul, fontWeight: '700', cursor: 'pointer' }}>Entrar</span>
            </div>

            <div style={{ textAlign: 'center', marginTop: '12px', fontSize: '12px', color: '#9CA3AF' }}>
              14 dias grátis · Sem cartão de crédito · Cancele quando quiser
            </div>

          </form>
        </div>
      </div>

      {/* MODAL CAMPOS OBRIGATÓRIOS */}
      {modalAberto && (
        <div onClick={() => setModalAberto(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(13,27,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()} role="alertdialog" aria-modal="true" aria-labelledby="modal-obrig-titulo"
            style={{ background: '#fff', borderRadius: '16px', padding: '28px', width: '100%', maxWidth: '380px', boxShadow: '0 12px 40px rgba(0,0,0,0.2)', textAlign: 'center' }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '12px' }}>
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <h3 id="modal-obrig-titulo" style={{ fontSize: '18px', fontWeight: '800', color: '#0D1B2A', margin: '0 0 8px' }}>Campos obrigatórios</h3>
            <div style={{ fontSize: '13px', color: '#6B7280', marginBottom: '12px' }}>Preencha os campos abaixo para continuar:</div>
            <ul style={{ textAlign: 'left', margin: '0 0 20px', padding: '12px 16px 12px 32px', background: '#FEF2F2', borderRadius: '10px', color: '#B91C1C', fontSize: '14px', lineHeight: 1.7 }}>
              {invalidos.map(c => <li key={c.k}>{c.msg || c.nome}</li>)}
            </ul>
            <button type="button" autoFocus onClick={() => setModalAberto(false)}
              style={{ width: '100%', padding: '12px', background: azul, border: 'none', color: '#fff', borderRadius: '10px', cursor: 'pointer', fontWeight: '700', fontSize: '15px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
